const dev = process.env.NODE_ENV === 'development';

// const devDomain = 'localhost';
const domain = process.env.REACT_APP_BASE_URL_API_ADMIN;
const domainInstallation = process.env.REACT_APP_BASE_URL_API_INSTALLATION;
const urlOperations = process.env.REACT_APP_BASE_URL_OPERATIONS;
const managerUrl = process.env.REACT_APP_BASE_URL_MANAGER;
const appUser = process.env.REACT_APP_USER;
const appKey = process.env.REACT_APP_KEY;
const mavimUrl = process.env.REACT_APP_BASE_URL_MAVIM;



const conf = {
    api: domain,
    cdnLogin: urlOperations,
    cdnGetFilesApiGroundTechnician: (fileName = '') =>
        `${domainInstallation}/files/${fileName}`,
    cdnGetFilesApiAdmin: (fileName = '') => domain + `/files/${fileName}`,
    auth: {},
    geocoding: {
        baseUrl: managerUrl,
        user: appUser,
        key: appKey
    },
    mavim: {
        baseUrl: mavimUrl
    }
};

export const { api, auth, cdnLogin, cdnGetFilesApiGroundTechnician, cdnGetFilesApiAdmin, geocoding, mavim } = conf;

export const headers = { 'Content-Type': 'application/json' };

export const defaultPage = 1;

export const defaultLimit = 20;

export const limitExport = 1000;

export const defaultOptionsForm = {
    value: null,
    label: 'home:none'
};

export const defaultEnabledOptionsForm = [
    {
        value: true,
        label: 'persons:enabled',
        checked: true
    },
    {
        value: false,
        label: 'persons:disabled',
        checked: false
    }
];


export const defaultGenderOptionsForm = [
    { ...defaultOptionsForm },
    {
        value: 'male',
        label: 'persons:male'
    },
    {
        value: 'female',
        label: 'persons:female'
    },
    {
        value: 'other',
        label: 'persons:other'
    }
];

export const defaultUnitsSlaOptionsForm = [
    { ...defaultOptionsForm },
    {
        value: 'day',
        label: 'home:day'
    },
    {
        value: 'hour',
        label: 'home:hours'
    },
    {
        value: 'minutes',
        label: 'home:minutes'
    }
];

export const defaultProfilesOptionsFilter = {
    value: null,
    label: 'profiles:all_profiles'
};

export const defaultCompaniesOptionsFilter = {
    value: null,
    label: 'tickets:all_companies'
};

export const defaultDealersStatusOptionsFilter = [
    {
        value: null,
        label: 'dealers:all_status'
    },
    {
        value: true,
        label: 'dealers:enabled'
    },
    {
        value: false,
        label: 'dealers:disabled'
    }
];

export const defaultDateTypeOptionsFilter = [
    {
        value: 'created.date',
        label: 'tickets:by_creation'
    },
    {
        value: 'scheduleInstallationDate',
        label: 'tickets:by_installation'
    },
    {
        value: 'scheduleSuggestedAppointment',
        label: 'tickets:by_scheduling'
    },
    {
        value: 'resolved.date',
        label: 'tickets:by_finalization'
    }
];

export const defaultStatusOptionsFilter = {
    _id: null,
    value: null,
    label: 'tickets:all_status'
};

export const defaultRemoteLockOptionsForm = [
    {
        value: true,
        label: 'home:yes',
        checked: true
    },
    {
        value: false,
        label: 'home:no',
        checked: false
    }
];

export const defaultAvailableOptionsForm = [
    {
        value: 'available',
        label: 'home:yes',
        checked: true
    },
    {
        value: 'not_available',
        label: 'home:no',
        checked: false
    }
];

export const defaultVolvoOptionsFilter = [
    {
        value: 'C 40',
        label: 'C 40'
    },
    {
        value: 'S 60',
        label: 'S 60'
    },
    {
        value: 'S 90',
        label: 'S 90'
    },
    {
        value: 'V 60',
        label: 'V 60'
    },
    {
        value: 'V 90',
        label: 'V 90'
    },
    {
        value: 'XC 40',
        label: 'XC 40'
    },
    {
        value: 'XC 60',
        label: 'XC 60'
    },
    {
        value: 'XC 90',
        label: 'XC 90'
    }
];

export const defaultFerrariOptionsFilter = [
        {
            value: 'CALIFORNIA',
            label: 'CALIFORNIA'
        },
        {
            value: 'CALIFORNIA T',
            label: 'CALIFORNIA T'
        },
        {
            value: 'PORTOFINO',
            label: 'PORTOFINO'
        },
        {
            value: 'PORTOFINO M',
            label: 'PORTOFINO M'
        },
        {
            value: 'ROMA',
            label: 'ROMA'
        },
        {
            value: '296',
            label: '296'
        },
        {
            value: 'SF90',
            label: 'SF90'
        },
        {
            value: '430',
            label: '430'
        },
        {
            value: '458',
            label: '458'
        },
        {
            value: '488',
            label: '488'
        },
        {
            value: 'F8',
            label: 'F8'
        },
        {
            value: 'FF',
            label: 'FF'
        },
        {
            value: 'GTC4LUSSO',
            label: 'GTC4LUSSO'
        },
        {
            value: 'F12',
            label: 'F12'
        },
        {
            value: '812',
            label: '812'
        },
        {
            value: 'PUROSANGUE',
            label: 'PUROSANGUE'
        }
];

export const defaultMaseratiOptionsFilter = [
   {
        value: 'GRANTURISMO',
        label: 'GRANTURISMO'
   },
   {
        value: 'GRANCABRIO',
        label: 'GRANCABRIO'
    },
    {
        value: 'GHIBLI',
        label: 'GHIBLI'
    } ,
    {
        value: 'QUATTROPORTE',
        label: 'QUATTROPORTE'
    } ,
    {
        value: 'QUATTROPORTE M156',
        label: 'QUATTROPORTE M156'
    },
    {
        value: 'LEVANTE',
        label: 'LEVANTE'
    }   
];

export const defaultBentleyOptionsFilter = [
    {
        value: 'CONTINENTAL',
        label: 'CONTINENTAL'
    },
    {
        value: 'CONTINENTAL GTC',
        label: 'CONTINENTAL GTC'
    },
    {
        value: 'FLYING SPUR',
        label: 'FLYING SPUR'
    },
    {
        value: 'BENTAYGA',
        label: 'BENTAYGA'
    }
]

export const defaultPeugeotOptionsFilter = [
    {
        value: '208',
        label: '208'
    },
    {
        value: '301',
        label: '301'
    },
    {
        value: '308',
        label: '308'
    },
    {
        value: '508 R8',
        label: '508 R8'
    },
    {
        value: 'RIFTER',
        label: 'RIFTER'
    },
    {
        value: '2008',
        label: '2008'
    },
    {
        value: '3008',
        label: '3008'
    },
    {
        value: '5008',
        label: '5008'
    },
    {
        value: 'PARTNER',
        label: 'PARTNER'
    },
    {
        value: 'TRAVELLER',
        label: 'TRAVELLER'
    },
    {
        value: 'EXPERT',
        label: 'EXPERT'
    },
    {
        value: 'BOXER',
        label: 'BOXER'
    },
    {
        value: 'LANDTREK',
        label: 'LANDTREK'
    },   
];

export const defaultOpelOptionsFilter = [
    {
        value: 'CORSA',
        label: 'CORSA'
    },
    {
        value: 'MOKKA',
        label: 'MOKKA'
    },
    {
        value: 'CROSSLAND',
        label: 'CROSSLAND'
    },
    {
        value: 'GRANDLAND',
        label: 'GRANDLAND'
    },
    {
        value: 'COMBO',
        label: 'COMBO'
    },
    {
        value: 'VIVARO',
        label: 'VIVARO'
    },
]

export const defaultCreditOperationOptionsForm = [
    {
        value: true,
        label: 'home:yes',
        checked: true
    },
    {
        value: false,
        label: 'home:no',
        checked: false
    }
]